import PropTypes from 'prop-types';

const NavChannels = ({ color, size, ...props }) => (
    <svg viewBox="0 0 32 32" width={size} height={size} {...props}>
        <g fill={color} fillRule="nonzero">
            <path d="M23.385 3c-2.55 0-4.616 2.108-4.616 4.71 0 2.6 2.067 4.709 4.616 4.709S28 10.31 28 7.709 25.934 3 23.385 3m0 1.884c1.529 0 2.769 1.265 2.769 2.825s-1.24 2.826-2.77 2.826c-1.529 0-2.769-1.265-2.769-2.826 0-1.56 1.24-2.825 2.77-2.825M8.615 11.79C6.066 11.79 4 13.9 4 16.5s2.066 4.71 4.615 4.71 4.616-2.11 4.616-4.71-2.067-4.71-4.616-4.71m0 1.884c1.53 0 2.77 1.265 2.77 2.826 0 1.56-1.24 2.826-2.77 2.826-1.529 0-2.769-1.265-2.769-2.826 0-1.56 1.24-2.826 2.77-2.826M23.385 20.581c-2.55 0-4.616 2.109-4.616 4.71S20.836 30 23.385 30 28 27.892 28 25.29c0-2.6-2.066-4.709-4.615-4.709m0 1.884c1.529 0 2.769 1.265 2.769 2.826 0 1.56-1.24 2.825-2.77 2.825-1.529 0-2.769-1.265-2.769-2.825s1.24-2.826 2.77-2.826" />
            <path d="M11.006 17.922a.913.913 0 0 1 1.262-.34l8.406 4.999c.44.262.59.838.333 1.288a.913.913 0 0 1-1.263.34l-8.406-4.999a.95.95 0 0 1-.332-1.288M19.732 8.792a.913.913 0 0 1 1.262.339.95.95 0 0 1-.332 1.288l-8.394 4.998a.913.913 0 0 1-1.262-.339.95.95 0 0 1 .332-1.288z" />
        </g>
    </svg>
);

export default NavChannels;

NavChannels.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
